import type { OrganizationScopeType } from "@/types/organization-scope"

// 单店升级连锁不切换预订系统；总部仍使用独立组织视图。
export function usesCentralReservation(scopeType: OrganizationScopeType | undefined) {
  return (scopeType === "shop" || scopeType === "chain-store")
    && import.meta.env.VITE_RESERVATION_WORKBENCH_FEATURE_ENABLED !== "false"
}
